// extracted by mini-css-extract-plugin
export default {"search_form__input":"SearchForm_search_form__input__hwLSp","SearchForm":"SearchForm_SearchForm__6Hj9H"};